import { render, staticRenderFns } from "./g-drag-block.vue?vue&type=template&id=96462936&scoped=true&"
import script from "./g-drag-block.vue?vue&type=script&setup=true&lang=ts&"
export * from "./g-drag-block.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./g-drag-block.vue?vue&type=style&index=0&id=96462936&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96462936",
  null
  
)

export default component.exports